"use client";

import MyImage from "@/image_layout/my_image";
import { images } from "@/lib/contants";
import { BsFillTriangleFill } from "react-icons/bs";
import { PiTriangle } from "react-icons/pi";

// import { useRouter } from "next/navigation";

import { MdAlternateEmail } from "react-icons/md";
import { FaRegEye, FaEyeSlash } from "react-icons/fa";
import { useActionState, useEffect, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { ProgressionBar } from "../widgets/progession_bar";
import { MdOutlinePassword } from "react-icons/md";
import { IoWallet } from "react-icons/io5";
import { IoIosRefresh } from "react-icons/io";

import {
  getClientCategoriesAction,
  getClientTypeAction,
  registerClient,
  resendOtpAction,
  sendOtpAction,
} from "@/actions/auth/auth_action";
import { clientCategoriesTypeData, clientTypeData } from "@/types/data";
import { ToastContainer } from "react-toastify";
import ToastHelper from "@/utils/toast_helper";
import Link from "next/link";

const initialState = {
  lastName: "",
  firstName: "",
  email: "",
  password: "",
  confirmPassword: "",
  errors: {},
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export function RegisterComponent() {
  const [visible, setVisible] = useState(false);
  const [visibleConf, setVisibleConf] = useState(false);

  const [clientTypeLoading, setClientTypeLoading] = useState(true);
  const [clientTypeListData, setClientTypeListData] =
    useState<clientTypeData[]>();

  const [clientCatListData, setClientCatListData] =
    useState<clientCategoriesTypeData[]>();
  const [clientCatLoading, setClientCatLoading] = useState(true);

  // const [pinValue, setPinValue] = useState("");
  const [step, setStep] = useState(1);

  // const router = useRouter();

  const [state, action, isPending] = useActionState(
    registerClient,
    initialState
  );

  const [stateOtp, actionOtp, isOtpPending] = useActionState(sendOtpAction, {
    errors: {},
    code: "",
  });

  const [stateOtpRegt, actionOtpReget, isPedidngOtpReget] = useActionState(
    resendOtpAction,
    { errors: {}, email: "" }
  );

  // ?? GETTING CLIENT TYPE LIST
  useEffect(() => {
    const loadClientType = async () => {
      try {
        const clientTypes = await getClientTypeAction();

        // console.log("TYPE C --- ", clientTypes);
        setClientTypeListData(clientTypes);
        setClientTypeLoading(false);
      } catch (error) {
        console.log("fetch clienttype on client error --- ", error);
        setClientTypeLoading(false);
      }
    };
    loadClientType();
  }, []);

  // ?? GETTING category TYPE LISt
  useEffect(() => {
    const loadClientCat = async () => {
      try {
        const clientCategories = await getClientCategoriesAction();
        // console.log("TYPE C --- ", clientTypes);
        setClientCatListData(clientCategories);

        setClientCatLoading(false);
      } catch (error) {
        console.log("fetch Cleint-Cat on client error --- ", error);
        setClientCatLoading(false);
      }
    };
    loadClientCat();
  }, []);

  // ? success message on registration validate
  useEffect(() => {
    if (state.success) {
      ToastHelper(state.message, true, false);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setStep(2);
    }
    if (!state.success) {
      ToastHelper(state.message, false, true);
    }
  }, [state]);

  // ? MESSAGE ON OTP
  useEffect(() => {
    if (stateOtp?.success) {
      ToastHelper(stateOtp.message, true, false);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setStep(3);
    }
    if (!stateOtp?.success) {
      ToastHelper(stateOtp?.message, false, true);
    }
  }, [stateOtp]);

  useEffect(() => {
    if (stateOtpRegt?.success) {
      ToastHelper(stateOtpRegt.message, true, false);
      // setStep(2);
    }
    if (!stateOtpRegt?.success) {
      ToastHelper(stateOtpRegt?.message, false, true);
    }
  }, [stateOtpRegt]);

  // console.log("THE  C L I E N T -- T Y P E :: ", clientTypeListData);
  // console.log("THE  C L I E N T -- C A T :: ", clientCatListData);

  return (
    <div className="flex min-h-screen items-center  w-full bg-linear-to-br from-brow-bgLight-linT to-brow-bgLight-linF ">
      <ToastContainer />
      {/* //? logo section */}
      <div className="hidden min-h-screen lg:flex flex-2 justify-center items-center  relative bg-brow-main ">
        {/* //? logo */}
        <div className="h-[20vh] w-[20vw] z-10 ">
          <MyImage alt="" imgPath={images.tajirikaLogo} />
        </div>

        {/* //? linear bg */}
        <Deco />
      </div>

      <div className="w-full p-4 lg:flex flex-col gap-8 flex-1 justify-center items-center bg-linear-to-br from-brow-bgLight-linT to-brow-bgLight-linF lg:px-8 ">
        {step == 3 && (
          <div className="h-40 w-40">
            <MyImage alt="" imgPath="/assets/suC.png" />
          </div>
        )}
        <div className="bg-white min-h-[20vh] flex flex-col relative p-2 w-full gap-10 pt-16 shadow-xl shadow-brow-main/15 rounded-sm ">
          {/* //? BAR PROGRESSION */}
          <ProgressionBar step={step} />
          {/* //? FORM */}
          {step == 1 && (
            <form
              action={action}
              className="w-full p-2 flex flex-col  justify-center items-center gap-10  "
            >
              {/* //? FORM */}
              <div className="w-full flex flex-col gap-2">
                 {/* //? username */}
                <div className="w-full relative flex flex-col  items-center ">
                  <input
                    type={"text"}
                    name={"username"}
                    placeholder={"Votre Nom d'utilisateur"}
                    defaultValue={state?.username}
                    className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full ${
                      state.errors && state.errors?.username
                        ? "border-red-500"
                        : "border-beige-dark"
                    } `}
                  />
                  {state.errors && state.errors?.username && (
                    <div className="text-red-500 w-full">
                      {state.errors?.username}
                    </div>
                  )}
                </div>
                {/* //? last-name */}
                <div className="w-full relative flex flex-col  items-center ">
                  <input
                    type={"text"}
                    name={"lastName"}
                    placeholder={"Votre Nom"}
                    defaultValue={state?.lastName}
                    className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full ${
                      state.errors && state.errors?.lastName
                        ? "border-red-500"
                        : "border-beige-dark"
                    } `}
                  />
                  {state.errors && state.errors?.lastName && (
                    <div className="text-red-500 w-full">
                      {state.errors?.lastName}
                    </div>
                  )}
                </div>

                {/* //? first-name */}
                <div className="w-full relative flex flex-col  items-center ">
                  <input
                    type={"text"}
                    name={"firstName"}
                    placeholder={"Votre Prenom"}
                    defaultValue={state?.firstName}
                    className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full ${
                      state.errors && state.errors?.firstName
                        ? "border-red-500"
                        : "border-beige-dark"
                    } `}
                  />
                  {state.errors && state.errors?.firstName && (
                    <div className="text-red-500 w-full">
                      {state.errors?.firstName}
                    </div>
                  )}
                </div>

                {/* //? email */}
                <div className="w-full relative flex flex-col  items-center ">
                  {/* prefix */}
                  <div className="flex items-center gap-2 absolute left-2 top-3 ">
                    <MdAlternateEmail className="text-2xl text-[#111] " />
                    <div className="h-5 w-px bg-stone-400 " />
                  </div>
                  <input
                    type={"text"}
                    name={"email"}
                    placeholder={"exemple@gmail.com"}
                    defaultValue={state?.email}
                    className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full pl-12 ${
                      state.errors && state.errors?.email
                        ? "border-red-500"
                        : "border-beige-dark"
                    } `}
                  />
                  {state.errors && state.errors?.email && (
                    <div className="text-red-500 w-full">
                      {state.errors?.email}
                    </div>
                  )}
                </div>

                {/* //? DIVIDER */}
                <div className="w-full border-dashed my-3 border-beige-dark border " />

                {/* //? password */}
                <div className="w-full relative flex flex-col  items-center ">
                  {/* prefix */}
                  <div className="flex items-center gap-2 absolute left-2 top-3 ">
                    <MdOutlinePassword className="text-2xl text-[#111] " />
                    <div className="h-5 w-px bg-stone-400 " />
                  </div>
                  <input
                    type={visible ? "text" : "password"}
                    name={"password"}
                    placeholder={"Entrez le mot secret"}
                    className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full pl-12 ${
                      state.errors && state.errors?.password
                        ? "border-red-500"
                        : "border-beige-dark"
                    } `}
                  />
                  {state.errors && state.errors?.password && (
                    <div className="text-red-500 w-full">
                      {state.errors?.password}
                    </div>
                  )}
                  <div
                    onClick={() => setVisible(!visible)}
                    className=" absolute right-2 top-3 cursor-pointer "
                  >
                    {visible ? (
                      <FaEyeSlash className="text-2xl text-[#111] " />
                    ) : (
                      <FaRegEye className="text-2xl text-[#111] " />
                    )}
                  </div>
                </div>

                {/* //? password confirm */}
                <div className="w-full relative flex flex-col  items-center ">
                  {/* prefix */}
                  <div className="flex items-center gap-2 absolute left-2 top-3 ">
                    <MdOutlinePassword className="text-2xl text-[#111] " />
                    <div className="h-5 w-px bg-stone-400 " />
                  </div>
                  <input
                    type={visibleConf ? "text" : "password"}
                    name={"confirmPassword"}
                    placeholder={"Entrez le mot secret"}
                    className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full pl-12 ${
                      state.errors && state.errors?.confirmPassword
                        ? "border-red-500"
                        : "border-beige-dark"
                    } `}
                  />
                  {state.errors && state.errors?.confirmPassword && (
                    <div className="text-red-500 w-full">
                      {state.errors?.confirmPassword}
                    </div>
                  )}

                  <div
                    onClick={() => setVisibleConf(!visibleConf)}
                    className=" absolute right-2 top-3 cursor-pointer "
                  >
                    {visibleConf ? (
                      <FaEyeSlash className="text-2xl text-[#111] " />
                    ) : (
                      <FaRegEye className="text-2xl text-[#111] " />
                    )}
                  </div>
                </div>

                {/* //? divider */}
                <div className="w-full border-dashed my-3 border-beige-dark border " />

                {clientTypeLoading ? (
                  <div className="bg-stone-200 rounded-md h-10 w-full animate-pulse " />
                ) : !clientTypeLoading && clientTypeListData == null ? (
                  <div />
                ) : (
                  <select
                    name="client_type"
                    id=""
                    className="border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full 
                        border-beige-dark pr-4 "
                  >
                    {clientTypeListData?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.client_type}
                        </option>
                      );
                    })}
                  </select>
                )}

                {clientCatLoading ? (
                  <div className="bg-stone-200 rounded-md h-10 w-full animate-pulse " />
                ) : !clientCatLoading && clientCatListData == null ? (
                  <div className="p-2 bg-orange-200 flex items-center justify-between ">
                    <p className="">
                      Certaninnes données n&apos;ont pas chargées, actualiser la
                      page
                    </p>
                    <span className="text-white text-2xl ">
                      <IoIosRefresh
                        onClick={() => {
                          window.location.reload();
                        }}
                      />
                    </span>
                  </div>
                ) : (
                  <select
                    name="client_category"
                    id=""
                    className="border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full 
                        border-beige-dark pr-4 "
                  >
                    {clientCatListData?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                )}
              </div>

              {/* //? BTN && LINK TO LOGIN PAGE */}
              <div className="w-full flex flex-row-reverse gap-2 items-center">
                {/* //? BTN */}
                <div className="w-full pr-2 pb-2 flex justify-end ">
                  {isPending ? (
                    <div className="w-full flex justify-end items-center pr-2 ">
                      <div className="animate-spin rounded-full h-8 w-8 border-l-brow-lin border-l-3 border-b-3 border-b-brow-main " />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      disabled={
                        clientCatLoading ||
                        clientTypeLoading ||
                        clientTypeListData == null ||
                        clientCatListData == null
                      }
                      className="px-6 py-1.5 transition-all duration-300 rounded-sm bg-brow-main text-white text-lg flex items-center hover:opacity-80 cursor-pointer disabled:bg-gray-500 disabled:cursor-not-allowed "
                    >
                      <span>Suivant</span>
                      <MdKeyboardArrowRight className="inline text-2xl  " />
                    </button>
                  )}
                </div>
                <div className="w-full flex flex-col  text-sm font-semibold items-start justify-center lg:text-lg ">
                  <p className="text-[#111]  ">Avez-vous déjà un compte?</p>
                  <Link href={"/login"} className="text-brow-main">
                    Se connecter
                  </Link>
                </div>
              </div>
            </form>
          )}

          {step == 2 && (
            <div>
              <form
                action={actionOtp}
                className="w-full p-2 flex flex-col  justify-center items-center gap-10"
              >
                <div className="flex flex-col text-center items-center ">
                  {/* //? Header text */}
                  <div className="w-[90%] flex flex-col items-center justify-center ">
                    <h2 className="text-2xl font-semibold text-center ">
                      Verifiez votre boite mail, puis coller les chiffres
                      secrets pour confirmer
                    </h2>
                    <p className="text-lg text-black-shade1 ">
                      Gardez-vous de montrer ces chiffres a une autre personne
                    </p>
                  </div>

                  <div className="w-full mt-4 flex flex-col justify-center items-center  relative ">
                    {/* <p>{state?.email}</p> */}
                    <input
                      type="string"
                      inputMode="numeric"
                      name="pin_code"
                      maxLength={8}
                      className="pl-8 text-3xl rounded-md p-2 w-[50%] outline-none text-center  tracking-[1.5rem]  border-2 border-gray-500 font-black "
                    />
                  </div>

                  <input
                    type="text"
                    name="email"
                    className="hidden"
                    defaultValue={state?.email}
                  />
                </div>
                {isOtpPending ? (
                  <div className="w-full flex justify-end items-center pr-2 ">
                    <div className="animate-spin rounded-full h-8 w-8 border-l-brow-lin border-l-3 border-b-3 border-b-brow-main " />
                  </div>
                ) : (
                  <button
                    type="submit"
                    // disabled={stateOtp?.pin_code.length == 0}
                    className="px-6 py-1.5 rounded-md bg-brow-main text-white cursor-pointer translate-all duration-300 hover:opacity-85 disabled:bg-gray-700   "
                  >
                    Valider
                  </button>
                )}
              </form>
              <div className="w-full text-xl flex justify-center gap-2 py-4  text-center ">
                N&apos;avez-vous pas recu les codes de validation?{" "}
                <form action={actionOtpReget} className={""}>
                  <input
                    type="text"
                    name="email"
                    className="hidden"
                    defaultValue={state?.email}
                  />
                  <button
                    type="submit"
                    className="text-brow-main cursor-pointer transition-all duration-300 hover:text-redT  "
                  >
                    {isPedidngOtpReget ? (
                      <div className="w-full flex justify-end items-center pr-2 ">
                        <div className="animate-spin rounded-full h-8 w-8 border-l-brow-lin border-l-3 border-b-3 border-b-brow-main " />
                      </div>
                    ) : (
                      <span>Reessayer!</span>
                    )}
                  </button>
                </form>
              </div>
            </div>
          )}

          {step == 3 && (
            <div className="p-2 flex flex-col gap-4  ">
              <div className="flex gap-4 items-center relative bg-brow-light-shade1 p-2 ">
                <div className="h-20 w-20 flex justify-center items-center bg-brow-light-shade2 rounded-md">
                  <span className="h-14 w-14 bg-brow-main flex justify-center items-center rounded-sm text-white ">
                    <IoWallet className="text-5xl " />
                  </span>
                </div>
                <div className="flex flex-col ">
                  <h2 className="text-[#111] text-xl font-bold">
                    Account name
                  </h2>
                  <p>Acount description</p>
                </div>
              </div>
              <div className="flex gap-4 items-center relative  bg-brow-light-shade1 p-2">
                <div className="h-20 w-20 flex justify-center items-center bg-brow-light-shade2 rounded-md">
                  <span className="h-14 w-14 bg-brow-main flex justify-center items-center rounded-sm text-white ">
                    <IoWallet className="text-5xl " />
                  </span>
                </div>
                <div className="flex flex-col ">
                  <h2 className="text-[#111] text-xl font-bold">
                    Account name
                  </h2>
                  <p>Acount description</p>
                </div>
              </div>

              <div className="w-full py-4 flex justify-between items-center ">
                <div className="px-6 py-1.5 rounded-md bg-brow-main text-white ">
                  Verifier le KYC
                </div>
                <Link
                  href={"/"}
                  className="px-6 py-1.5 rounded-md text-brow-main transition-all duration-300 font-semibold cursor-pointer hover:bg-brow-light-shade2 "
                >
                  Ignore et commencer
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Deco() {
  return (
    <div className="min-h-screen flex items-end w-full absolute top-0 left-0 bg-linear-to-b from-transparent to-brow-lin ">
      <div className="h-[50vh] w-full flex justify-center items-center  overflow-hidden  ">
        <BsFillTriangleFill className="text-brow-main rotate-2 translate-y-[2vh] translate-x-[10vw] text-6xl " />
        <PiTriangle className="text-brow-main rotate-45 translate-y-[14vh] -translate-x-[1vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main rotate-20 -translate-y-[10vh] -translate-x-[10vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main -rotate-20 -translate-y-[10vh] translate-x-[6vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-y-[20vh] translate-x-[5vw] -rotate-22 text-6xl " />
        <BsFillTriangleFill className="text-brow-main rotate-60 translate-x-[12vw] -translate-y-[10vh] text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-x-[25vw] -translate-y-[2vh] rotate-36 text-6xl " />
        <PiTriangle className="text-brow-main -rotate-17 translate-y-[14vh] -translate-x-[30vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-y-[10vh] translate-x-[5vw] rotate-18 text-6xl " />
        <PiTriangle className="text-brow-main translate-y-[15vh] translate-x-[12vw] -rotate-5 text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-y-[18vh] translate-x-[18vw] -rotate-18 text-6xl " />
        <PiTriangle className="text-brow-main translate-y-[6vh] -translate-x-[16vw] -rotate-18 text-6xl " />
        <PiTriangle className="text-brow-main translate-y-[6vh] translate-x-[16vw] rotate-18 text-6xl " />
        <BsFillTriangleFill className="text-brow-main -rotate-2 translate-x-[12vw] -translate-y-[16vh] text-6xl " />
        <BsFillTriangleFill className="text-brow-main -translate-x-[50vh] -translate-y-[16vw] -rotate-45 text-6xl " />
        <PiTriangle className="text-brow-main -translate-x-[10vw] -translate-y-[10vh] rotate-10 text-6xl " />
        <BsFillTriangleFill className="text-brow-main -translate-x-[45vw] -translate-y-[4vh] rotate-16 text-6xl " />
        <PiTriangle className="text-brow-main -translate-x-[45vw] -translate-y-[16vh] -rotate-16 text-6xl " />
      </div>
    </div>
  );
}

// function AccountCreated() {
//   return (
//     <div className="flex flex-col text-center items-center w-full">
//       {/* //? Header text */}
//       <div className="w-[90%] flex  items-center justify-center ">
//         <h2 className="text-2xl font-semibold text-center ">Comptes Crees</h2>
//       </div>

//       <div className="w-full flex flex-col gap-2 mt-4">
//         <div className="flex items-center gap-4 relative rounded-md p-2 bg-beige-C border border-beige-dark  ">
//           <span className="h-14 w-14 bg-brow-main flex justify-center items-center rounded-sm text-white ">
//             <IoWallet className="text-5xl " />
//           </span>
//           <div className="flex flex-col items-start ">
//             <h2 className="text-xl text-blackT font-semibold ">Tajirika</h2>
//             <p className=" text-black-shade2  ">Compte par defaut</p>
//           </div>

//           <span className="absolute font-bold top-2 right-3 text-xl text-[#111]  ">
//             CDF
//           </span>
//         </div>
//         <div className="flex items-center gap-4 relative rounded-md p-2 bg-beige-C border border-beige-dark  ">
//           <span className="h-14 w-14 bg-brow-main flex justify-center items-center rounded-sm text-white ">
//             <IoWallet className="text-5xl " />
//           </span>
//           <div className="flex flex-col items-start ">
//             <h2 className="text-xl text-blackT font-semibold ">Tajirika</h2>
//             <p className=" text-black-shade2  ">Compte par defaut</p>
//           </div>

//           <span className="absolute font-bold top-2 right-3 text-xl text-[#111]  ">
//             UDS
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// }
